var map = {
	"./4G-5G/en-us.json": [
		97827,
		7827
	],
	"./IOT-SIM/en-us.json": [
		53040,
		3040
	],
	"./app/en-us.json": [
		5454,
		5454
	],
	"./bulkUpload/en-us.json": [
		30752,
		752
	],
	"./bussProduct/en-us.json": [
		17223,
		7223
	],
	"./bussProductQA/en-us.json": [
		21401,
		1401
	],
	"./checkout/en-us.json": [
		41167,
		1167
	],
	"./credit-result/en-us.json": [
		84332,
		4332
	],
	"./marketPlaceQA/en-us.json": [
		91751,
		1751
	],
	"./npa/en-us.json": [
		11038,
		1038
	],
	"./qualificationLanding/en-us.json": [
		90315,
		315
	],
	"./shoppingCart/en-us.json": [
		47576,
		7576
	],
	"./suspend/en-us.json": [
		37426,
		7426
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 84496;
module.exports = webpackAsyncContext;